@if (service.isModalOpen()) {
  <app-dialog
    type="modal"
    size="600px"
    height="min(760px, 100%)"
    heading="Perfil de compra"
    headingAlign="start"
    headingSize="13px"
    headingColor="var(--primary-color-alt)"
    [showBack]="isQuestion()"
    (backRequest)="previousStep()"
    [class.purchase-profile-dialog--highlight-title]="isIntro() || isResult()"
    (closeRequest)="dismissModal()"
  >
    
    @if (isQuestion()) {
      <div class="progress-section">
        <span class="progress-label">{{ progressText() }}</span>
        <div class="progress-track">
          <div class="progress-fill" [style.width]="progressPct()"></div>
        </div>
      </div>
    }
        
        @if (isIntro()) {
          <div class="step-container step-intro">
            <div class="intro-headline">
              @if (isReviewIntro()) {
                <h1 class="main-title">Hora de revisar o perfil de compra da sua loja</h1>
                <p class="main-desc">Confira se as suas respostas continuam valendo.</p>
              } @else {
                <h1 class="main-title">Descubra o perfil de compra da sua loja</h1>
                <p class="main-desc">
                  São 5 perguntas rápidas, como num perfil de investidor. Com elas a gente entende onde está a sua margem.
                </p>
              }
            </div>

            <div class="intro-benefits">
              <div class="benefit-row">
                <span class="benefit-icon">
                  <i class="fa-solid fa-bullseye" aria-hidden="true"></i>
                </span>
                <span class="benefit-text">
                  @if (isReviewIntro()) {
                    Confira se a margem que a loja busca continua a mesma
                  } @else {
                    Veja primeiro os veículos com a margem que você busca
                  }
                </span>
              </div>
              <div class="benefit-row">
                <span class="benefit-icon">
                  <i class="fa-solid fa-sliders" aria-hidden="true"></i>
                </span>
                <span class="benefit-text">
                  @if (isReviewIntro()) {
                    Atualize marcas, modelos, ano e km se algo mudou
                  } @else {
                    Refine marcas, modelos, ano e km quando quiser
                  }
                </span>
              </div>
            </div>
          </div>
        }

        @if (isQuestion()) {
          <div class="step-container step-question">
            <div class="question-header">
              <span class="question-icon-wrapper">
                <i class="fa-solid" [ngClass]="currentQuestion().icon" aria-hidden="true"></i>
              </span>
              <h1 class="question-title">{{ currentQuestion().title }}</h1>
              <p class="question-desc">{{ currentQuestion().desc }}</p>
            </div>

            
            @if (currentQuestion().insight && service.fipeAverageFormatted(); as fipeAverage) {
              <div class="insight-card">
                <span class="insight-badge">{{ fipeAverage }}</span>
                <span class="insight-text">
                  é a <strong>média de venda na plataforma</strong> frente à FIPE hoje
                </span>
                <i class="fa-solid fa-chart-line insight-icon" aria-hidden="true"></i>
              </div>
            }

            
            @if (currentQuestion().locNote) {
              <div class="location-note">
                <i class="fa-solid fa-store" aria-hidden="true"></i>
                <span>{{ storeInfoDisplay() }}</span>
              </div>
            }

            
            <div
              class="options-list"
              [attr.role]="currentQuestion().multi ? 'group' : 'radiogroup'"
              [attr.aria-label]="currentQuestion().title"
            >
              @for (option of currentQuestion().options; track option.id) {
                <button
                  type="button"
                  class="option-card"
                  [class.option-card--selected]="isOptionSelected(option.id)"
                  [attr.aria-pressed]="currentQuestion().multi ? isOptionSelected(option.id) : null"
                  (click)="toggleOption(option)"
                >
                  <span class="option-icon">
                    <i class="fa-solid" [ngClass]="option.icon" aria-hidden="true"></i>
                  </span>

                  <span class="option-content">
                    <span class="option-label">{{ option.label }}</span>
                    @if (option.sub) {
                      <span class="option-sub">{{ option.sub }}</span>
                    }
                  </span>

                  @if (currentQuestion().multi) {
                    <app-checkbox
                      [checked]="isOptionSelected(option.id)"
                      [readonly]="true"
                      size="md"
                    ></app-checkbox>
                  } @else {
                    <app-radio
                      [value]="option.id"
                      [name]="currentQuestion().id"
                      [checked]="isOptionSelected(option.id)"
                      [readonly]="true"
                      size="md"
                    ></app-radio>
                  }
                </button>
              }
            </div>

            @if (currentQuestion().multi && canProceedCurrentQuestion()) {
              <div class="summary-hint">
                <span>{{ currentQuestion().summaryLabel }}: <strong>{{ getQuestionSummary() }}</strong></span>
              </div>
            }
          </div>
        }

        
        @if (isResult()) {
          <div class="step-container step-result">
            
            <div class="profile-card">
              @if (currentProfile(); as profile) {
                <div class="profile-badge-row">
                  <span class="profile-icon">
                    <i class="fa-solid" [ngClass]="profile.icon" aria-hidden="true"></i>
                  </span>
                  <span class="profile-badge-text">
                    Perfil de compra: <strong>{{ profile.name }}</strong>
                  </span>
                </div>

                <h1 class="profile-headline">{{ profile.headline }}</h1>

                <p class="profile-description">
                  @for (part of profile.parts; track $index) {
                    @if (part.isBold) {
                      <strong>{{ part.text }}</strong>
                    } @else {
                      <span>{{ part.text }}</span>
                    }
                  }
                </p>
              } @else {
                <div class="profile-badge-row">
                  <span class="profile-icon">
                    <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                  </span>
                  <span class="profile-badge-text">
                    Perfil de compra: <strong>{{ savedProfileName() }}</strong>
                  </span>
                </div>
              }

              <div class="profile-actions">
                <button type="button" class="btn btn-white" (click)="goToStep(1)">
                  <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
                  Refazer perfil
                </button>
              </div>
            </div>

            @if (isLoadingMatches() || matchingCount() > 0) {
              <div class="match-count-card">
                <span class="match-count-number">
                  @if (isLoadingMatches()) {
                    <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                  } @else {
                    {{ matchingCount() }}
                  }
                </span>
                <span class="match-count-text">
                  @if (isLoadingMatches()) {
                    Calculando veículos que combinam com o seu perfil...
                  } @else if (matchingCount() === 1) {
                    veículo combina com o seu perfil <strong>agora</strong>
                  } @else {
                    veículos combinam com o seu perfil <strong>agora</strong>
                  }
                </span>
                <span class="match-count-icon">
                  <i class="fa-solid fa-car-side" aria-hidden="true"></i>
                </span>
              </div>

              <div class="suggestions-section">
                <div class="suggestions-header">
                  <span class="suggestions-title">Sugestões para você</span>
                  <span class="suggestions-badge">
                    <i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i>
                    pelo seu perfil
                  </span>
                </div>

                @if (isLoadingMatches()) {
                  <div class="suggestions-loading-state">
                    <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                    <span>Buscando veículos que combinam com seu perfil...</span>
                  </div>
                } @else {
                  <div class="suggestions-viewport">
                    <button
                      type="button"
                      class="suggestions-arrow suggestions-arrow--prev"
                      [class.suggestions-arrow--hidden]="!canScrollSuggestionsPrev()"
                      aria-label="Ver sugestões anteriores"
                      (click)="scrollSuggestions(-1)"
                    >
                      <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
                    </button>

                    <div
                      class="suggestions-cards-row"
                      #suggestionsTrack
                      (scroll)="onSuggestionsScroll()"
                    >
                      @for (vehicle of matchingVehicles(); track vehicle.id) {
                        <app-purchase-profile-vehicle-card
                          [vehicle]="vehicle"
                        ></app-purchase-profile-vehicle-card>
                      }
                    </div>

                    <button
                      type="button"
                      class="suggestions-arrow suggestions-arrow--next"
                      [class.suggestions-arrow--hidden]="!canScrollSuggestionsNext()"
                      aria-label="Ver próximas sugestões"
                      (click)="scrollSuggestions(1)"
                    >
                      <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
                    </button>
                  </div>
                }
              </div>
            } @else {
              <div class="empty-suggestions-state">
                <div class="empty-icon-wrap">
                  <i class="fa-solid fa-car-rear" aria-hidden="true"></i>
                </div>
                <p class="empty-title">Ainda não há veículos com o seu perfil agora.</p>
                <p class="empty-desc">Assim que surgirem, eles aparecem na sua home.</p>
              </div>
            }

            
            <div class="answers-summary-section">
              <h2 class="answers-summary-title">Suas respostas</h2>
              <div class="answers-summary-list">
                @for (row of summaryRows(); track row.stepIndex) {
                  <div class="answers-summary-row">
                    <span class="summary-row-icon">
                      <i class="fa-solid" [ngClass]="row.icon" aria-hidden="true"></i>
                    </span>
                    <div class="summary-row-info">
                      <span class="summary-row-label">{{ row.label }}</span>
                      <span class="summary-row-value">{{ row.value }}</span>
                    </div>
                    <button
                      type="button"
                      class="summary-row-action"
                      (click)="goToStep(row.stepIndex)"
                    >
                      Alterar
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        }
    
    <div dialog-footer class="purchase-profile-footer">
      @if (isIntro()) {
        <div class="footer-actions footer-actions--intro">
          <button
            type="button"
            class="btn btn-primary btn-cta"
            (click)="nextStep()"
          >
            @if (isReviewIntro()) {
              Revisar perfil
            } @else {
              Descobrir meu perfil
            }
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="footer-dismiss-btn"
            (click)="dismissModal()"
          >
            Agora não
          </button>
        </div>
      } @else if (isQuestion()) {
        @if (showQuestionAction()) {
          <div class="footer-actions">
            <button
              type="button"
              class="btn btn-white"
              (click)="previousStep()"
            >
              Voltar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!canProceedCurrentQuestion() || service.isSaving()"
              (click)="nextStep()"
            >
              @if (service.isSaving() && isLastQuestion()) {
                <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                Salvando perfil...
              } @else if (isLastQuestion()) {
                Ver meu perfil
              } @else {
                Continuar
              }
            </button>
          </div>
        } @else {
          <div class="footer-single-hint">
            <i class="fa-regular fa-hand-pointer" aria-hidden="true"></i>
            <span>Escolha uma opção para seguir</span>
          </div>
        }
      } @else if (isResult()) {
        <div class="footer-actions">
          <button
            type="button"
            class="btn btn-primary btn-cta"
            [disabled]="service.isSaving()"
            (click)="continueFromResult()"
          >
            @if (service.isSaving()) {
              <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
              Salvando...
            } @else {
              Continuar
            }
          </button>
        </div>
      }
    </div>
  </app-dialog>
}
